import { IModel } from './annotation';
import { Folder } from '../folder/folder';
import { TaggableNamed } from './taggable-named';
import { Owned, Named } from './named';

export abstract class A365Named extends TaggableNamed {

    public static readonly MODEL: IModel;

    // resourceType + name should be able to identify a unquie resource
    // currently, we wil use tree view id as resource Type
    public resourceType: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public icon: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public tabOptions: any;

    public contextValue: string;

    public isEditable: boolean = false;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public originalObject: any;

    public folder: Folder = Owned.create(Folder.MODEL, this);

    public isLeaf: boolean = true;

    public customTooltip?: string;

    public readonly useShellFolder?: boolean;

    /**
     * If true, the entity will always be directly fetched from and saved to backend and never go into git repo.
     */
    public readonly liveOnly: boolean = false;

    /**
     * If true, the entity will always not be stored in arm template for CI/CD
     */
    public readonly excludedInArmTemplate: boolean = false;

    /**
     * Unique Identifier in case the duplicate names are allowed.
     * For example, for Power BI, the repord ID can be set here so the node can be uniquely
     * identified even if another Power BI node has the same name.
     */
    public uniqueIdentifier?: string;

    constructor(name?: string, description?: string, uniqueId?: string) {
        super(name, description);
        this.uniqueIdentifier = uniqueId;
    }

    public setAsFolder(parent?: Named): void {
        let myPath = this.name;

        if (parent) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let parentPath = (parent as any).folder.name || '';
            if (parentPath.endsWith('/')) {
                parentPath = parentPath.substring(0, parentPath.length - 1);
            }
            myPath = parentPath ? parentPath + '/' + this.name : this.name;
        }

        this.folder = new Folder(myPath);
        this.isLeaf = false;
    }

    public setAsLeaf(parent?: Named): void {
        if (!this.useShellFolder) {    // useShellFolder means another way to set folder
            this.folder = parent ? new Folder((parent as A365Named).folder.name) : new Folder('');
        }
        this.isLeaf = true;
    }

    /**
     * Get the full-name of an A365Named.
     * Only support two-level named, enough for now.
     * Example:
     *      For `fileSystem1` under `storageAccount1`, it's `storageAccount1/fileSystem1`.
     *      For `storageAccount1`, it's `storageAccount1`.
     */
    public get fullName(): string {
        const parentName = this.folder.name;
        return parentName ? `${parentName}/${this.name}` : this.name;
    }

    public equals(named: Named): boolean {
        return super.equals(named) ||
            (named instanceof A365Named &&
                !!this.uniqueIdentifier &&
                this.uniqueIdentifier === named.uniqueIdentifier &&
                this.resourceType === named.resourceType &&
                this.fullName === named.fullName);
    }
}
